import {apiClient} from '../../../util/api-client';

export async function getCanAddBookmark(): Promise<boolean> {
  if (window[`mp`] && mp.report && mp.report.globals) {
    const workspaceId = mp.report.globals.workspace_id;
    const baseUrl = workspaceId ? `/api/app/workspaces/${workspaceId}` : `/report/${mp.report.globals.project_id}`;
    // bookmarks api is not APIResponse compatible
    // eslint-disable-next-line local-rules/deprecated-member-access
    const fetchResponse = await apiClient.fetch(`${baseUrl}/bookmarks/limited_count/`, {throwOnInvalidStatus: true});
    const jsonResponse = await fetchResponse.json();
    return jsonResponse.bookmark_count < mp.report.globals.feature_gates[`max_saved_reports`];
  } else {
    return false;
  }
}
